import { take, all, takeLatest, call, put, fork, select } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { feature, jobs, actions, selectors, testName } from './config';
import {} from '@app/state';
import { PayloadAction } from '@reduxjs/toolkit';
import { tryJob } from '@app/lib/saga';

export const sagas = [forking];

function* forking() {
  yield takeLatest(feature.initPattern, init);
  yield takeLatest(actions.gotoNextTest.toString(), gotoNextTest);
}

function* init() {
  try {
    const statementIdList = yield select(selectors.enterStatements.getStatementHashedIds);
    yield call(tryJob, jobs.loadTestSettings, { test: testName, statementIdList });
  } catch (err) {
    console.error(err);
  }
}

function* gotoNextTest() {
  const skipNarration = yield select(selectors.enterStatements.skipNarration);
  if (skipNarration) {
    yield put(actions.gotoResultSummary());
  } else {
    yield put(actions.gotoTestNarration());
  }
}
